import styled from "styled-components";
import { FC } from "react";
import { components } from "react-select";

import { InputVariant, SelectComponentProps } from "./types";
import { getTextVariant } from "./getTextVariant";
import { styleWrappedComponent } from "./styleWrappedComponent";
import { inputTypography } from "./inputTypography";

type StyledPlaceholderProps = { variant: InputVariant };
const StyledPlaceholder = styled.div<StyledPlaceholderProps>`
  ${(props) => styleWrappedComponent(inputTypography(props.variant))};
`;

type PlaceholderProps = SelectComponentProps["Placeholder"];

export const Placeholder: FC<PlaceholderProps> = ({ children, ...props }) => (
  <StyledPlaceholder variant={getTextVariant(props)}>
    {!props.isFocused && (
      <components.Placeholder {...props}>{children}</components.Placeholder>
    )}
  </StyledPlaceholder>
);
